module.exports = __webpack_public_path__ + "img/avatar-07.8a62d437.png";